import { lazy, Suspense } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import Loader from "./utils/Loader";
const Home = lazy(() => import("./pages/Home/index"));

export const HomeRedirect = () => {
  const usertype = useSelector((state) => state.account.accountType);

  if (usertype === "real") {
    return <Navigate to="/user" />;
  }
  return usertype === "demo" ? (
    <Navigate to="/demo" />
  ) : (
    <Suspense
      fallback={<Loader/>}
    >
      <Home />
    </Suspense>
  );
};
